// extracted by mini-css-extract-plugin
export default {"tile-badge":"daily-specials1iPmUI","tile-badge__label":"daily-specialswQCShG","tile-badge__label--super-offer":"daily-specialsRaT66f"};